import { TRootState, TProviderState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { providerAdapter } from './adapter'

const selectState = (state: TRootState): TProviderState => state.providers

const adapterSelectors = providerAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

const totalItems = createSelector(
    selectState,
    (state) => (state.totalItems)
)

export const selectors = {
    ...adapterSelectors,
    fetchStatus,
    totalItems,
}